var _defs, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformanceEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1502.96 991.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #dcddef;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        isolation: isolate;\n      }\n\n      .cls-2, .cls-8 {\n        opacity: .43;\n      }\n\n      .cls-10 {\n        stroke: #1a3987;\n        stroke-width: .5px;\n      }\n\n      .cls-10, .cls-11, .cls-12, .cls-13, .cls-5, .cls-14, .cls-15, .cls-16 {\n        fill: none;\n      }\n\n      .cls-10, .cls-16 {\n        stroke-linejoin: round;\n      }\n\n      .cls-17 {\n        fill: #ffe1ad;\n      }\n\n      .cls-18, .cls-19, .cls-4, .cls-20 {\n        fill: #fff;\n      }\n\n      .cls-21 {\n        fill: #c8cced;\n      }\n\n      .cls-22 {\n        fill: #383838;\n      }\n\n      .cls-23 {\n        fill: #bf6e58;\n      }\n\n      .cls-11 {\n        stroke: #d19b4b;\n        stroke-width: .57px;\n      }\n\n      .cls-11, .cls-12, .cls-13, .cls-5, .cls-20, .cls-14, .cls-15 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-19, .cls-24 {\n        fill-rule: evenodd;\n      }\n\n      .cls-25 {\n        fill: #3dba85;\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-12 {\n        stroke: #5c6e87;\n        stroke-width: 1.19px;\n      }\n\n      .cls-13 {\n        stroke: #3dba85;\n        stroke-dasharray: 7.97 7.97;\n        stroke-width: .74px;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3, .cls-7, .cls-9 {\n        opacity: .25;\n      }\n\n      .cls-27 {\n        fill: #e3e3ff;\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-29 {\n        fill: #c5cbd3;\n      }\n\n      .cls-30 {\n        fill: #f7958b;\n      }\n\n      .cls-31 {\n        fill: #fd7011;\n      }\n\n      .cls-4 {\n        opacity: .5;\n      }\n\n      .cls-24 {\n        fill: #8b71d3;\n      }\n\n      .cls-32 {\n        fill: #f99316;\n      }\n\n      .cls-5 {\n        opacity: .44;\n        stroke: #fafafa;\n        stroke-linecap: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-20 {\n        stroke: #e1e1e1;\n        stroke-width: 1.28px;\n      }\n\n      .cls-6 {\n        opacity: .11;\n      }\n\n      .cls-33 {\n        fill: #bac6ce;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-14 {\n        stroke: #ef977f;\n        stroke-width: 1.02px;\n      }\n\n      .cls-15 {\n        stroke: #4c3f89;\n        stroke-width: .64px;\n      }\n\n      .cls-34 {\n        fill: #ff855a;\n      }\n\n      .cls-35 {\n        fill: #ffcbbb;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-36 {\n        fill: #3e83ff;\n      }\n\n      .cls-37 {\n        fill: #989fa8;\n      }\n\n      .cls-38 {\n        fill: #f09171;\n      }\n\n      .cls-16 {\n        stroke: #3e4293;\n        stroke-width: .63px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3.96,
    y1: -19879.53,
    x2: 46.22,
    y2: -19879.53,
    gradientTransform: "translate(14804.4 -14099.84) rotate(43.78) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4279e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5fb7b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 31.47,
    y1: -19902.66,
    x2: 166.76,
    y2: -19902.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 19607.97,
    y1: -11145.54,
    x2: 19902.24,
    y2: -11145.54,
    gradientTransform: "translate(20391.97 -10762.3) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4279e8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5fb7b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 19296.24,
    y1: -11127.25,
    x2: 19737.47,
    y2: -11127.25,
    gradientTransform: "translate(20391.97 -10762.3) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 19605.33,
    y1: -11294.28,
    x2: 19869.6,
    y2: -11294.28,
    gradientTransform: "translate(22597.24 6502.21) rotate(-135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d35400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb62d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 19701.98,
    y1: -10936.19,
    x2: 20051.32,
    y2: -10936.19,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 19701.98,
    y1: -10967.46,
    x2: 19898.21,
    y2: -10967.46,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 366.94,
    cy: 948.64,
    rx: 169.54,
    ry: 10.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1182.2,
    cy: 827.08,
    r: 56.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1043.56,
    cy: 793.03,
    r: 118.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 916.38,
    cy: 842.18,
    r: 44.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M344.77,379.41s-25.44,7.61-25.69,35.18c-.25,27.56,9.85,36.99,9.85,36.99,0,0,30.2-2.25,30.2-2.71s1.18-16.99,1.18-16.99l-1.18-18.41-14.35-34.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M334.83,425.94s-24.84-2.23-24.84,15.99c0,18.22,24.95,27.25,26,27.04,1.05-.22,17.64-11.5,17.64-11.5l-18.81-31.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 975.23,
    y: 492.49,
    width: 43.97,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 975.21,
    y: 514.95,
    width: 65.97,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1008.21,
    y: 537.44,
    width: 49.66,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1078.19,
    y: 559.94,
    width: 66.43,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1154.52,
    y: 559.94,
    width: 55.34,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1008.19,
    y: 559.94,
    width: 23.44,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 974.16,
    y: 582.43,
    width: 24.46,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1009.64,
    y: 582.43,
    width: 67.24,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 974.16,
    y: 604.93,
    width: 30.14,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1017.65,
    y: 604.93,
    width: 25.6,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1057.88,
    y: 604.93,
    width: 42.72,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1114.35,
    y: 604.93,
    width: 42.72,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 974.16,
    y: 627.44,
    width: 24.46,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1012.37,
    y: 627.44,
    width: 64.52,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 974.16,
    y: 649.93,
    width: 24.46,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1007.86,
    y: 649.93,
    width: 24.46,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1040.11,
    y: 649.93,
    width: 24.46,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1074.16,
    y: 649.93,
    width: 52.85,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1134.17,
    y: 649.93,
    width: 35.32,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1031.63,
    y: 492.49,
    width: 56.03,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1097.82,
    y: 492.49,
    width: 64.52,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1172.6,
    y: 492.49,
    width: 74.49,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1258.78,
    y: 492.49,
    width: 35.23,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1125.82,
    y: 468.07,
    width: 26.36,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1041.06,
    y: 559.94,
    width: 26.36,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1050.98,
    y: 514.95,
    width: 26.36,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1066.95,
    y: 537.44,
    width: 26.36,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1162.34,
    y: 468.07,
    width: 13.15,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1183.92,
    y: 468.07,
    width: 34.18,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1228.29,
    y: 468.07,
    width: 37.7,
    height: 14.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1106.76,
    y: 514.02,
    width: 19.37,
    height: 19.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1141.11,
    y: 514.02,
    width: 19.37,
    height: 19.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1061.55,285.8c24.35-8.18,75.37-47.77,84.89-79.71,9.52-31.94-8.41-45.91-17.61-41.44-8.49,4.12-13.88,20.95-19.8,41.28-5.92,20.33-27.94,55.22-47.69,62.28l.22,17.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1138.57,176.15c1.54,12.36-11.46,65.95-70.86,99.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1071.74,296.57c4.76-15.23,9.94-43.13,28.85-47.44,18.91-4.31,17.02,13.79,30.54,12.08,13.52-1.71,18.31-20.79,30.18-22.42,22.89-3.18,15.63,19.15,25.71,25,7.27,4.18,26.18-2.51,41.44,15.26,15.26,17.77,1.62,30.25-11.9,29.33-13.52-.93-28.36-3.27-31.65,11.65-2.91,13.25-15.08,31.16-38.28,20.3-22.18-10.37-20.89,4.83-31.36,10.48-10.47,5.65-33.76-1.82-44.42-24.27l.89-29.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1223.46,288.91c-22.89-12.72-100.59-19.22-147.17,21.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1165.3,322.88c-7.01-10.74-29.56-33-42.1-37.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1166.33,251.35s-5.72,19.35-17.17,29.22"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 636.86,
    cy: 383.24,
    r: 147.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 786.63,
    cy: 602.51,
    r: 66.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 843.83,
    cy: 696.75,
    r: 28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 875.11,
    cy: 364.94,
    r: 220.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 654.48,
    cy: 531.98,
    r: 132.11,
    transform: "translate(-184.47 618.6) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M300.25,848.69l-5.63,69.66-.49,21.91,53.22-.51c1.73,0,6,.94,5.98-1.14h0c0-1.58-3.63-5.65-4.89-6.21l-20.93-12.36,8.39-72.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M364.61,938.81c-.71-2.74-2.02-5.83-3.34-6.52l-32.07-16.9c-17.68,8.79-40.57,2.11-40.57,2.11l-4.11,29.58c-.11.9.54,1.71,1.43,1.81,0,0,.01,0,.02,0h78.13c1.54-.15.55-9.99.51-10.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M336.08,917.08c-1.83,2.93-3.35,6.05-4.52,9.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M340.17,920.04c-1.46,2.51-2.68,5.16-3.63,7.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M343.59,922.18c-1.31,2.35-2.48,4.77-3.49,7.27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 284.94,
    y1: 942.46,
    x2: 364.94,
    y2: 941.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M287.17,928s18.81.44,20.4,14.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M354.69,928.81s-5.2,9.08-6.21,13.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M373.99,848.52l6.54,69.64-.51,21.91,53.24-.51c1.71,0,5.98.96,5.98-1.14h0c0-1.56-3.63-5.65-4.89-6.2l-20.95-12.37-3.76-72.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M450.55,938.61c-.73-2.74-2.03-5.83-3.36-6.54l-32.05-16.88c-17.7,8.79-40.57,2.11-40.57,2.11l-4.12,29.58c-.1.9.55,1.71,1.45,1.82l78.13-.09c1.51-.05.53-9.9.53-9.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M422.04,916.88c-1.83,2.94-3.35,6.05-4.54,9.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M426.08,919.82c-1.48,2.51-2.7,5.16-3.63,7.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M429.49,921.98c-1.33,2.34-2.5,4.77-3.51,7.27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 370.82,
    y1: 942.24,
    x2: 450.84,
    y2: 941.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M373.08,927.78s18.79.45,20.39,14.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M440.58,928.61s-5.18,9.08-6.21,13.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M310.41,574.16l-1.62,5c-6.39,19.77-10.39,40.22-11.92,60.94-.27,3.78-.55,7.81-.78,12.06-2.74,48.28-6.6,254.84-6.6,254.84h48.73s29.42-256.61,34.52-311.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M403.31,587.97c12.9,96.88,13.97,319.05,13.97,319.05h-49.24s-13.19-291.49-25.69-319.05"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 339.37,
    y1: 895.16,
    x2: 290.1,
    y2: 895.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 416.36,
    y1: 895.16,
    x2: 367.66,
    y2: 895.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M362.05,705.57c10.61,123.39,15.21,201.46,15.21,201.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M301.98,604.56s21.11,9.27,39.3,12.14c18.19,2.87,41.34,2.13,64.85-2.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M354.25,757.68s13.45-101.55,12.61-138.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M372.66,618.64s-.42,29.83-1.31,31.18c-.89,1.34-5.45,2.36-5.45,2.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M308.34,607.43c-3.39,16.48-5.89,33.13-7.47,49.87-3.27,31.49-4.78,248.92-4.78,248.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M340.83,617.3c-7.04,15.15-21.75,25.29-38.41,26.47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 347.53,
    y1: 617.54,
    x2: 347.53,
    y2: 604.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 388.32,
    y1: 616.7,
    x2: 388.32,
    y2: 602.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M393.7,616.46s6.61,15.53,13.85,16.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M377.15,427.7l.45,18.17s-3.82,10.9-11.94,9.72c-8.58-1.31-11.03-10.3-11.03-10.3l.71-27.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M382.29,379.12c8.09,8.9,18.86,41.7,4.27,49.35-15.39,8.05-33.98,1.93-39.21-19.19-5.52-22.17,13.72-53.56,34.94-30.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M377.26,431.59c-4.71-.24-11.85-2.02-20.26-8.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M349.11,406.84c.05.06.1.13.15.2h0s-.11.05-.15,0c0,0,0,0,0,0l-.13-.2s-.01-.06,0-.09h0s.09-.05.13-.02c0,0,.01.01.02.02v.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M350.04,424.74c12.43-20.35,10.61-32.96,10.61-32.96,0,0,28-1.93,33.1-6.65-.85-11.07-15.55-20.93-27.64-14.3-19.73-7.27-30.69,10.74-32.89,20.95-2.78,12.85,5.98,29.07,16.81,32.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M359.7,409.37c-.58-1.58-1.97-2.72-3.63-2.96-4.03-.64-5.45,4.76-4.2,8.59.67,2.28,2.03,4.3,3.91,5.76,2.58,2.11,5.45,2.13,6.34-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M422.41,502.54s8.43,19.71,10.45,22.15c11.46,13.85,29.94-53.74,29.94-53.74l22.98,15.86s-13.77,71.99-41.44,87.59c-27.67,15.61-59.96-52.15-59.96-52.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M461.16,476.61c2.53-10.74,8.85-39.72,10.56-39.97,1.71-.25.25,10.05,1.62,9.45,1.36-.6,4.47-16.35,6.25-16.13,2.42.29-1.51,16.24-1.51,16.24,0,0,1.29-3.09,3.33-2.11,1.44.71,1.09,5.21,1.09,5.21,0,0,1.53-3.45,3-2.69,1.47.76,1.13,6.07,1.13,6.07,0,0,1.34-1.67,2.74-1.05s2.45,9.76-5.05,42.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M472.68,450.09c-.12,1.38-.08,2.77.13,4.14.18,1.38.51,2.74.98,4.05.45,1.22.84,2.45,1.22,3.72.37,1.28.67,2.59.89,3.91.52-1.32.73-2.75.6-4.16-.1-1.41-.4-2.8-.89-4.12-.83-2.57-1.8-5.09-2.93-7.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M477.8,447.42c-.3,1.6-.52,3.22-.65,4.85-.22,1.68-.17,3.39.15,5.05.07.27.19.52.35.74.24.34.64.53,1.05.51.58-.08,1.11-.4,1.45-.87.56-.68,1.03-1.43,1.4-2.23.72-1.51,1.33-3.07,1.82-4.67l-1.82-.38c-.31,1.6-.54,3.22-.69,4.85,0,.82-.13,1.65-.13,2.49-.05.92.05,1.84.31,2.73.12.31.28.6.49.85.35.37.84.55,1.34.51.64-.1,1.22-.43,1.62-.94.57-.71,1.02-1.52,1.33-2.38.57-1.57,1-3.19,1.27-4.83l-1.69-.27c-.15,1.51-.24,3-.27,4.49-.07,1.53.02,3.05.27,4.56.08.43.22.85.42,1.24.16.28.42.48.73.56.31.07.64-.01.89-.22.6-.57,1.03-1.29,1.25-2.09.49-1.41.83-2.88,1.02-4.36-.42,1.41-.96,2.78-1.6,4.11-.25.62-.65,1.16-1.16,1.58-.27,0,0,.09-.24-.11-.1-.29-.17-.59-.2-.89-.12-1.43-.12-2.86,0-4.29.13-1.45.31-2.93.51-4.36.07-.46-.24-.88-.69-.96-.01,0-.02,0-.03,0-.44-.06-.85.24-.94.67h0c-.33,1.52-.77,3-1.33,4.45-.25.65-.59,1.26-1.02,1.82-.2.22-.38.31-.4.29s.27,0,.27.09c-.05-.06-.08-.13-.09-.2-.26-1.45-.3-2.93-.13-4.4.15-1.56.35-3.16.56-4.71h0c.08-.46-.23-.91-.69-.99-.02,0-.04,0-.06,0-.44-.06-.86.21-.98.64-.4,1.53-.9,3.04-1.49,4.51-.49,1.34-1.82,3.27-1.82,2.11-.4-1.52-.59-3.08-.58-4.65.09-1.67.11-3.23.2-4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M378.62,447.42s-1.16,5.65-11.7,5.65-15.17-9.41-15.17-9.41c0,0-24,2.67-38.99,46.62-14.99,43.95-6.85,101.75-6.85,101.75l98.37,13.03s-2.53-19.88.38-69.19c.45-7.78,4.78-21.35,1.05-39.7-5.6-27.84-27.09-48.75-27.09-48.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.86,600.93l66.28,1.09v4.03s-69.99-1.16-69.99-1.16h0c-.05-2.11,1.6-3.87,3.71-3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M487.85,607.38l-93.12-1.54,18.5-61.78c.82-3.07,3.58-5.21,6.76-5.23l84.18,1.38c1.64.12,2.87,1.55,2.75,3.19-.02.26-.07.51-.15.75l-18.91,63.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M492.03,607.43l-93.1-1.53,18.48-61.78c.82-3.06,3.59-5.2,6.76-5.23l84.18,1.38c1.65.12,2.89,1.56,2.76,3.22-.02.25-.07.49-.15.73l-18.93,63.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M464.92,574.27c-.97,3.17-3.96,5.29-7.27,5.14-3.43,0-5.76-2.45-5.18-5.34.97-3.16,3.96-5.27,7.27-5.12,3.43.05,5.76,2.45,5.18,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M328.45,509.65s-1.82,57.05,2.67,65.59c2.58,5,49.57,15.04,49.57,15.04l.33,29.31s-59.49-2.16-75.11-27.71c-11.7-19.13-10.03-82.31-10.03-82.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M351.75,443.65s-25.67,3.07-38.48,17.48c-19.22,21.6-20.64,55.83-20.64,55.83h45.7s.49-29.07.49-29.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M378.62,447.42c15.24,1.82,27.05,9.68,33.3,20.28,9.72,16.46,16.53,41.95,16.53,41.95l-36.05,12.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M338.32,516.97c.36-21.8,2.33-32.12,2.33-32.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M408.22,516.71c1.49-18.59-9.58-38.16-9.58-38.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M370.32,588.06c6.27,1.07,39.26,7.65,38.85,9.39-.42,1.74-10.12,1.47-9.85,2.42.4,1.34,7.56,3.07,11.68,3.63,3.63.51,9.45,1.96,9.41,3.63-.11,3.23-20.19.13-20.19.13,0,0,22.29-.87,22.48,1.82.27,3.89-23.33,3.89-24.18,4.74,0,0,20.62-5.91,20.82-3.03.2,2.87-18.17,8.63-23.71,8.29,4.69-.62,19.06-8.01,19.13-5.36.07,2.65-12.36,6.54-14.34,6.72-10.34.8-20.74.12-30.89-2.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M417.97,606.72c-2.61-.47-5.24-.78-7.89-.94-2.63-.18-5.27-.31-7.94-.27,1.29.36,2.6.62,3.92.8,1.31.22,2.63.33,3.94.44,1.31.11,2.65.15,3.98.15,1.33,0,2.65-.02,3.98-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M415.59,610.89c-2.89,0-5.74.29-8.59.49-2.85.2-5.69.47-8.58.53,1.41.34,2.85.53,4.31.55,1.45.05,2.9.02,4.34-.09,1.44-.13,2.87-.29,4.29-.55,1.43-.22,2.84-.53,4.23-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M411.92,614.86c-2.58.15-5.12.51-7.65.89l-7.58,1.25c1.28.15,2.58.19,3.87.11,1.29-.07,2.58-.2,3.85-.42,1.27-.2,2.54-.42,3.8-.74,1.26-.29,2.49-.66,3.71-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M354.85,437.22s2.94,13.99,13.77,15.77l-5.72,12.92c-11.96-7.27-13.28-22.26-13.28-22.26l5.23-6.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M378.07,440.06c.87,6.16-3.32,11.89-9.45,12.94l5.14,12.16c4.38-4.74,7.05-10.82,7.56-17.26l-3.25-7.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 871.83,
    y: 712.22,
    width: 286.86,
    height: 58.21,
    rx: 29.11,
    ry: 29.11
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "965.49 877.03 1033.93 820.98 1076.67 741.58 974.41 741.58 1034.7 821.54 1096.71 855.24 1137.83 782.48 1209.34 842.18 1262.65 769.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1209.34,
    y1: 842.18,
    x2: 1096.71,
    y2: 855.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1076.67,
    y1: 741.58,
    x2: 1096.71,
    y2: 855.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 1096.71,
    y1: 855.24,
    x2: 1209.34,
    y2: 842.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 965.49,
    cy: 877.03,
    r: 15.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 1033.93,
    cy: 820.98,
    r: 15.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 974.41,
    cy: 741.58,
    r: 15.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1076.67,
    cy: 741.58,
    r: 15.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1096.71,
    cy: 855.24,
    r: 15.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 1137.83,
    cy: 782.48,
    r: 15.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 1209.34,
    cy: 842.18,
    r: 15.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1262.65,
    cy: 769.49,
    r: 15.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 908.86,
    cy: 741.58,
    r: 11.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M894.39,750.55c-4.97-7.98-2.53-18.48,5.45-23.45,7.98-4.97,18.48-2.53,23.45,5.45,4.97,7.98,2.53,18.48-5.45,23.45-7.98,4.97-18.48,2.54-23.45-5.44,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 340.64,
    y: 167.26,
    width: 349.34,
    height: 13.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 493.76,
    y: 198.53,
    width: 196.23,
    height: 13.26
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x5F_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M936.91,458.68h-43.88l-8.63-57.41,6.47-15.4c3.74-1.73,7.19-4.17,10.22-7.05h11.08c15.25,0,27.62,12.37,27.62,27.62v49.35c0,1.58-1.29,2.88-2.88,2.88ZM887.13,458.68h-24.17l8.2-54.96h7.77l8.2,54.96ZM870.58,397.96l-3.88-9.64c2.59.72,5.47,1.01,8.34,1.01,3.02,0,5.76-.29,8.49-1.01l-4.03,9.64h-8.92ZM857.06,458.68h-43.74c-1.58,0-2.88-1.29-2.88-2.88v-49.35c0-15.25,12.37-27.62,27.62-27.62h11.08c2.88,2.88,6.33,5.32,10.22,7.05l6.33,15.4-8.63,57.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M875.04,384.58c-17.98,0-32.52-14.68-32.52-32.66s14.53-32.52,32.52-32.52,32.66,14.68,32.66,32.52-14.68,32.66-32.66,32.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M995.04,383.86h-31.51c-1.58,0-2.88-1.29-2.88-2.88,0-14.53-3.6-28.63-10.5-41.29l16.98-22.59c2.3-3.02,2.01-7.34-.72-10.07-2.73-2.73-7.05-3.02-10.07-.72l-11.65,8.92,19.14-18.99c21.15,22.16,34.1,51.94,34.1,84.74,0,1.58-1.29,2.88-2.88,2.88ZM933.46,318.26c-15.11-13.96-34.67-22.16-55.54-22.73v-37.26c31.65.72,60.43,13.52,81.87,33.96l-26.33,26.04ZM872.17,295.52c-21.44.72-40.86,9.35-55.54,23.02l-26.33-26.19c21.44-20.57,50.21-33.38,81.87-34.1v37.26ZM812.6,322.57c-14.39,15.4-23.16,35.97-23.16,58.41,0,1.58-1.29,2.88-2.88,2.88h-31.37c-1.58,0-2.88-1.29-2.88-2.88,0-32.8,12.95-62.59,33.96-84.6l26.33,26.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M905.26,374.08c4.46-6.19,7.19-13.81,7.19-22.16,0-1.87-.14-3.88-.43-5.76l47.19-35.97c1.15-.86,2.88-.72,3.88.29s1.01,2.59.29,3.74l-45.61,60.29c-1.87-.29-3.74-.43-5.61-.43h-6.91Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M709.54,514.94c-.25.61-.81.98-1.46.98h-12.62c-.87,0-1.58.71-1.58,1.58v68.33c0,1.06-.86,1.92-1.91,1.92h-17.21c-1.06,0-1.91-.86-1.91-1.92v-68.33c0-.87-.72-1.58-1.58-1.58h-12.62c-.65,0-1.21-.37-1.46-.98s-.12-1.26.34-1.72l24.71-24.72c.62-.62,1.62-.62,2.24,0l24.72,24.72c.46.46.59,1.12.34,1.72h0ZM655.22,538.63h-17.21c-1.05,0-1.91.86-1.91,1.92v45.28c0,1.06.86,1.92,1.91,1.92h17.21c1.05,0,1.91-.86,1.91-1.92v-45.28c0-1.06-.86-1.92-1.91-1.92ZM618.47,553.16h-17.21c-1.05,0-1.91.86-1.91,1.92v30.74c0,1.06.86,1.92,1.91,1.92h17.21c1.06,0,1.91-.86,1.91-1.92v-30.74c0-1.06-.86-1.92-1.91-1.92ZM637.54,527.53l-2.9-1.47c-.38-.2-.8-.18-1.17.04-1.53.9-3.21,1.59-4.97,2.06-.42.11-.72.4-.86.81l-1,3.08c-.17.51-.62.84-1.17.84h-4.15c-.54,0-1-.33-1.17-.84l-1-3.08c-.13-.41-.44-.7-.86-.81-1.76-.46-3.43-1.16-4.97-2.06-.37-.22-.79-.23-1.17-.04l-2.9,1.47c-.48.25-1.04.16-1.42-.22l-2.93-2.94c-.39-.39-.47-.94-.23-1.42l1.47-2.89c.2-.39.18-.81-.03-1.18-.9-1.53-1.59-3.2-2.06-4.97-.11-.42-.4-.72-.81-.86l-3.08-1c-.51-.17-.85-.62-.85-1.16v-4.15c0-.54.34-1,.85-1.17l3.08-1c.4-.13.7-.43.81-.85.46-1.76,1.16-3.43,2.06-4.97.21-.37.23-.79.03-1.17l-1.47-2.89c-.24-.48-.16-1.04.23-1.42l2.93-2.94c.39-.38.95-.47,1.42-.23l2.9,1.48c.38.2.8.18,1.17-.04,1.54-.9,3.21-1.59,4.97-2.06.42-.11.72-.4.86-.81l1-3.08c.17-.51.62-.85,1.17-.85h4.15c.54,0,1,.34,1.17.85l1,3.08c.13.41.44.7.86.81,1.76.46,3.43,1.16,4.97,2.06.37.22.8.23,1.17.04l2.9-1.48c.48-.24,1.04-.15,1.42.23l2.93,2.94c.39.38.47.94.23,1.42l-1.47,2.89c-.2.39-.18.81.03,1.17.9,1.54,1.6,3.21,2.06,4.97.1.42.4.72.8.85l3.09,1c.51.17.84.63.84,1.17v4.15c0,.54-.33,1-.84,1.16l-3.09,1c-.4.13-.7.44-.81.86-.46,1.76-1.16,3.43-2.06,4.97-.21.37-.23.79-.03,1.18l1.47,2.89c.24.48.16,1.04-.23,1.42l-2.93,2.94c-.38.38-.94.47-1.42.22ZM633.8,508.82c0-5.74-4.65-10.39-10.38-10.39s-10.39,4.65-10.39,10.39,4.65,10.38,10.39,10.38,10.38-4.65,10.38-10.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceEvaluation);
export default __webpack_public_path__ + "static/media/performance-evaluation.dacd38fbdc359adc28cdba0e13d6da1b.svg";
export { ForwardRef as ReactComponent };